<div class="app-main flex-column flex-row-fluid" id="kt_app_main">
  <div class="d-flex flex-column flex-column-fluid">
    <div class="container-fluid">
      <div class="container-fluid">
        <div class="row">
          <!-- Patient Details -->
          <div class="col">
            <div class="container-fluid mt-1 ps-0">
              <div class="card d-flex p-4 px-7">
                <div class="row align-items-center">
                  <div class="col-md-6 mt-2">
                    <h5 class="card-subtitle">
                      {{ patientHeaderInformations?.name || "-" }}
                      {{ patientHeaderInformations?.lastName || "-" }},
                      {{ patientHeaderInformations?.age || "-" }},
                      {{ patientHeaderInformations?.gender[0] || "-" }}
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container-fluid flex-row-fluid">
        <div class="row">
          <!-- Left Column -->
          <div class="col">
            <div class="py-5 px-0 ms-0">
              <div class="card me-3">
                <button class="fullscreen-button">
                  <i class="fa-solid fa-expand"></i>
                </button>
                <div class="card-body">
                  <!-- Tabs -->
                  <ul
                    class="nav nav-tabs nav-line-tabs nav-line-tabs-2x mb-5 fs-6"
                    role="tablist"
                  >
                    <li
                      *ngFor="let tab of tabs"
                      class="nav-item"
                      role="presentation"
                      [ngStyle]="{
                        display: tab.display
                      }"
                    >
                      <a
                        (click)="selectTab(tab)"
                        class="nav-link text-gray-800"
                        [ngClass]="{
                          'active': tab.active,
                        }"
                        data-bs-toggle="tab"
                        [href]="tab.href"
                        [attr.aria-selected]="tab.active"
                        tabindex="-1"
                        role="tab"
                        >{{ tab.name | translate }}</a
                      >
                    </li>
                  </ul>

                  <div class="tab-content" id="myTabContent">
                    <!-- Case Detail Tab Content -->
                    <div
                      class="tab-pane fade show active"
                      id="caseDetail"
                      role="tabpanel"
                    >
                      <app-case-information
                        [patientHeaderInformations]="patientHeaderInformations"
                        [diabetesCaseInformation]="diabetesCaseInformation"
                        [consultationId]="consultationId"
                      />
                    </div>
                    <!-- AI Report Informations Tab Content -->
                    <div class="tab-pane fade" id="aiReport" role="tabpanel">
                      <ng-container *ngIf="activeTabList.includes('aiReport')">
                        <app-ai-report [consultationId]="consultationId" />
                      </ng-container>
                    </div>
                    <!-- Conclusion Tab Content -->
                    <div class="tab-pane fade" id="conclusion" role="tabpanel">
                      <ng-container
                        *ngIf="activeTabList.includes('conclusion')"
                      >
                        <app-conclusion
                          [patientHeaderInformations]="
                            patientHeaderInformations
                          "
                          [selectedConclusionText]="selectedConclusionText"
                          [patientRecordCaseDetail]="patientRecordCaseDetail"
                          [currentUser]="currentUser"
                          [consultationId]="consultationId"
                          [patientCaseDetails]="patientCaseDetails"
                          [diabetesCaseInformation]="diabetesCaseInformation"
                        />
                      </ng-container>
                    </div>
                    <!-- Chat With GP Tab Content -->
                    <div class="tab-pane fade" id="chatWithGp" role="tabpanel">
                      <ng-container
                        *ngIf="activeTabList.includes('chatWithGp')"
                      >
                        <app-chat
                          [currentUser]="currentUser"
                          [patientHeaderInformations]="
                            patientHeaderInformations
                          "
                          [consultationId]="consultationId"
                          (patientInfoRequested)="
                            getPatientInformations($event)
                          "
                        ></app-chat>
                      </ng-container>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Consultation Timelines -->
      <div *ngIf="consultationId" class="container-fluid">
        <div class="row">
          <div class="col">
            <div class="container-fluid mt-1 pb-20 ps-0">
              <div class="card">
                <div class="container-fluid">
                  <div class="row">
                    <div class="card-header border-0 pt-5">
                      <h3 class="card-title align-items-start flex-column">
                        <span class="card-label fw-bold fs-3 mb-1">{{
                          "consultationTimeLine" | translate
                        }}</span>
                      </h3>
                    </div>
                    <div
                      *ngIf="timeLineList && timeLineList?.length; else noCase"
                      class="container"
                    >
                      <div class="time-line">
                        <div
                          *ngFor="let timeline of timeLineList; let i = index"
                          class="time-line-item"
                          [class.selected-item]="selectedIndex === i"
                          (click)="showCaseDetails(i, timeline)"
                        >
                          <div class="time-line-dot"></div>
                          <h4>
                            {{
                              timeline?.createdDate
                                ? (timeline.createdDate | date : "dd-MM-yyyy")
                                : "-"
                            }}
                          </h4>
                        </div>
                      </div>
                    </div>
                    <ng-template #noCase>
                      <div class="no-case-found">
                        {{ "noCaseToBeDisplayed" | translate }}
                      </div>
                    </ng-template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
